import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';

import Modal from 'common/Modal/Modal';
import { postFormData, showModal } from 'reduxStore/actions/miceActionDispatcher';
import { checkForError, formatMiceForm, hotelFilterData } from 'UtilityComponents/miceUtils';
import { getQuotesFields, MiceQueryModalData } from '../../config';
import GetQuoteForm from './MiceForm';
import { trackClick } from 'UtilityComponents/venueUtils';

const GetQuote = ({ isMobile, apiLoader }) => {
	const dispatch = useDispatch();
	const modalData = useSelector((state) => state.mice.modalData);
	const searchFilterData = useSelector((state) => state.mice.searchFilterData);

	const { selectedHotelData } = modalData;

	const closeModal = () => {
		let payload = {
			modalType: ''
		};
		dispatch(showModal(payload));
	};

	const handleSubmit = useCallback((e) => {
		e.preventDefault();
		const error = checkForError(formFields);
		if (error) return;
		const formData = formatMiceForm(formFields);
		const filterData = hotelFilterData(selectedHotelData, searchFilterData);
		let payloadData = {
			...formData,
			...filterData

		};
		trackClick('query_submitted');
		dispatch(postFormData(payloadData));
	}, [dispatch, formFields, selectedHotelData, searchFilterData]);

	const formFields = useMemo(() => cloneDeep(getQuotesFields), []);
	return (
		<Modal
			close
			Modaldata={MiceQueryModalData}
			width='510px'
			style={{ height: '570px' }}
			handleModal={closeModal}
			isResponsive
			isMobile={isMobile}>
			<GetQuoteForm
				isMobile={isMobile}
				handleSubmit={handleSubmit}
				formFields={formFields}
				showLoader={apiLoader}
			/>
		</Modal>
	);
};

export default GetQuote;
